import React, { useState } from 'react';
import ToggleView from '../../Toggle';
import MonthlyLeaderboard from './Monthly';
import TotalLeaderboard from './Total';

const Leaderboard = (props) => {
  const [view, setView] = useState(
    props.contest_months?.length > 3 ? 'monthly' : 'total'
  );

  const toggleView = (e) => {
    const newView =
      e.target.dataset.view || (view === 'monthly' ? 'total' : 'monthly');

    setView(newView);
  };

  return (
    <>
      <div className='w-full flex justify-end mb-4'>
        <ToggleView
          toggleView={toggleView}
          currentView={view}
          viewNameLeft='Monthly view'
          viewLeft='monthly'
          viewNameRight='Total view'
          viewRight='total'
        />
      </div>
      <div className='w-full'>
        {view === 'monthly' ? (
          <MonthlyLeaderboard {...props} />
        ) : (
          <TotalLeaderboard {...props} />
        )}
      </div>
    </>
  );
};

export default Leaderboard;
